import { render, staticRenderFns } from "./InnerPageTitle.vue?vue&type=template&id=d861f81e&"
import script from "./InnerPageTitle.vue?vue&type=script&lang=js&"
export * from "./InnerPageTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\carli\\Documents\\Github\\Sharo Employee New\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d861f81e')) {
      api.createRecord('d861f81e', component.options)
    } else {
      api.reload('d861f81e', component.options)
    }
    module.hot.accept("./InnerPageTitle.vue?vue&type=template&id=d861f81e&", function () {
      api.rerender('d861f81e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Base/InnerPageTitle.vue"
export default component.exports